module.exports = __webpack_public_path__ + "img/ahmed.441eaf07.png";